<template>
  <div class="modal fade bs-example-modal-lg" id="edit-rentals-price" aria-hidden="true" aria-labelledby="exampleGrid" role="dialog">
    <div class="modal-dialog modal-simple modal-center modal-medium">
      <div class="modal-content" >
        <div class="modal-header">
          <div class="container">
            <div class="row header">
              <div class="col-8">
                  <h4 class="modal-title">Select Rentals</h4>
              </div>
              <div class="col-4">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="decline('#edit-rentals-price')">
                  <span aria-hidden="true" class="close-btn">&times;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div>
                <div class="multi-select-rentals">
                  <div v-if="!smallLoading" class="checkbox-custom m-l-10 checkbox-primary">
                    <input type="checkbox" id="all-rentals" v-model="areAllRentalsChecked" @change="filterByRentals('all')">
                    <label for="all-rentals">
                      {{ $t('automation.index.all') }}
                    </label>
                  </div>
                  <ul v-if="!smallLoading" class="checkbox-custom m-l-30 checkbox-primary">
                    <ul v-for="group in modifiedGroups" v-if="group.rentals.length > 0" class="checkbox-custom m-l-30 checkbox-primary" style="margin-left: 10px">
                      <input type="checkbox" @change="filterByRentals(group.id)" v-model="checkedGroups[group.id]" :id="group.name">
                      <label :for="group.name">
                        <span class="rental-name">{{ group.name === 'others' ? $t('groups.others') : group.name }}</span>
                      </label>
                      <li v-for="rental in group.rentals" class="checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item">
                        <input type="checkbox" @change="filterByRentals()" v-model="checkedRentals[rental.id]" :id="rental.name">
                        <label :for="rental.name">
                          <span class="rental-name">{{ rental.name }}</span>
                        </label>
                      </li>
                    </ul>
                  </ul>
                  <v-loading :isLoading="smallLoading" :height="50" :width="50" :viewbox="'0 0 50 50'" :cx="25" :cy="25" :r="22" :isHeightAuto="true"></v-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer text-center">
          <button type="button" class="btn waves-effect waves-classic btn-cancel" data-dismiss="modal" @click.prevent="decline('#edit-rentals-price')" :disabled="smallLoading">
            {{ buttonDecline }}
          </button>
          <button type="submit" class="btn btn-primary waves-effect waves-classic btn-save" @click="confirm()" :disabled="smallLoading">
            {{ buttonConfirm }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixins/mixin';
import rentalService from '../../../services/rental';
import Vue from 'vue';

export default {
  name: 'MultiSelect',
  props: [
    'rental',
    'isUpdatedValue',
    'enableOpenModal',
  ],
  data() {
    return {
      groups: [],
      modifiedGroups: [],
      areAllRentalsChecked: false,
      checkedGroups: [],
      checkedRentals: [],
      buttonConfirm: '',
      buttonDecline: '',
      rentalsIds: [],
      newRentals: [],
      smallLoading: false,
    };
  },
  mixins: [mixin],
  async mounted() {
    await this.setLang();
    this.buttonConfirm = this.$t('button.save');
    this.buttonDecline = this.$t('button.cancel');
  },
  methods: {
    setLang() {
      Vue.config.lang = localStorage.getItem('lang');
    },
    filterByRentals(id = null) {
      if (id === 'all') {
        this.groups.map((group) => {
          Vue.set(this.checkedGroups, group.id, this.areAllRentalsChecked);
          const groupRentals = group.rentals;
          groupRentals.map((rental) => {
            Vue.set(this.checkedRentals, rental.id, this.areAllRentalsChecked);
          });
        });
        this.$forceUpdate();
      } else if (id != null) {
        const group = this.groups.filter(g => g.id === id)[0];
        const groupRentals = group.rentals;
        groupRentals.map((rental) => {
          Vue.set(this.checkedRentals, rental.id, this.checkedGroups[id]);
        });
        this.groups.map((group) => {
          if (group && group.rentals.length !== 0 && !this.checkedGroups[group.id]) {
            this.areAllRentalsChecked = false;
            return;
          }
          this.areAllRentalsChecked = true;
        });
      } else {
        for (let i = 0; i < this.groups.length; i++) {
          const group = this.groups[i];
          for (let j = 0; j < group.rentals.length; j++) {
            const rental = group.rentals[j];
            if (!this.checkedRentals[rental.id]) {
              Vue.set(this.checkedGroups, group.id, false);
              break;
            }
            Vue.set(this.checkedGroups, group.id, true);
          }
        }
        for (let j = 0; j < this.groups.length; j++) {
          if (this.groups[j] && this.groups[j].rentals.length !== 0 && !this.checkedGroups[this.groups[j].id]) {
            this.areAllRentalsChecked = false;
            break;
          }
          this.areAllRentalsChecked = true;
        }
      }
    },
    confirm() {
      if (this.checkedRentals.length > 0) {
        this.checkedRentals.map((id, index) => {
          if (id) {
            this.rentalsIds = [
              ...this.rentalsIds,
              index,
            ];
          }
        });
        if (this.rentalsIds.length > 0) {
          this.smallLoading = true;
          this.$emit('changeRestriction', this.rentalsIds);
        } else {
          toastr.error('Please select rentals');
        }
      } else {
        toastr.error('Please select rentals');
      }
    },
    decline() {
      this.$emit('closeMultiSelectModal');
      this.correctModal();
    },
    correctModal() {
      this.closeModal('#edit-rentals-price');
      this.rentalsIds = [];
      this.checkedRentals = [];
      this.checkedGroups = [];
      this.areAllRentalsChecked = [];
      this.smallLoading = false;
    },
  },
  components: {
    VLoading: require('components/loading/loading.vue'),
  },
  watch: {
    enableOpenModal(val) {
      if (val) {
        this.smallLoading = true;
        rentalService.getRentalGroups(this);
      }
    },
    groups(val) {
      if (val) {
        const groups = [...val];
        groups.map((group) => {
          group.rentals.map((rental) => {
            if (rental.id === this.rental.id) {
              const index = group.rentals.findIndex(groupRental => groupRental.id === this.rental.id);
              group.rentals.splice(index, 1);
            }
          });
        });
        this.modifiedGroups = groups;
      }
    },
    isUpdatedValue(val) {
      if (val) {
        this.correctModal();
        this.$emit('updateModal');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiSelect.vue?bb344be6